import React from 'react'
import { Link } from 'react-router-dom'
const guidetails = () => {
    return (
        <>
            <main id="main">
                <section id="breadcrumbs" class="breadcrumbs">
                    <div class="container">

                        <div class="d-flex justify-content-between align-items-center">
                            <h2>Python GUI (Desktop Application)</h2>
                            <ol>
                                <li><Link to='/'>Home</Link></li>
                                <li>School Projects</li>
                            </ol>
                        </div>

                    </div>
                </section>

                <section id="portfolio-details" class="portfolio-details">
                    <div class="container">

                        <div class="row gy-4">

                            <div class="col-lg-8">
                                <div class="portfolio-details-slider swiper">
                                    <div class="swiper-wrapper align-items-center">

                                    </div>
                                    <div class="swiper-pagination">
                                    <div class="swiper-slide">
                                            <img src="assets/img/images/gui2.png" alt="" />
                                        </div>

                                        <div class="swiper-slide">
                                            <img src="assets/img/images/gui1.png" alt="" />
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <div class="col-lg-4">
                                <div class="portfolio-info">
                                    <h3>Project information</h3>
                                    <ul>
                                        <li><strong>Category</strong>: Python OOPS </li>
                                        <li><strong>Project Category</strong>: School Project </li>
                                        <li><strong>Project date</strong>: 01 March, 2020</li>
                                        <li><strong>Project Code</strong>: Github <a href="#">github.com/anshvarshney20/</a></li>
                                    </ul>
                                </div>
                                <div class="portfolio-description">
                                    <h2>About The GUI Projects</h2>
                                    <p>
                                        PyQt5 is a very well-known GUI framework used by both Python coders and UI designers. One of its components, the PyQt package, is built around the Qt framework, which is a leading cross-platform GUI design tool for just about any kind of application.
                                    </p>
                                </div>
                            </div>

                        </div>

                    </div>
                </section>
            </main>
        </>
    )
}

export default guidetails